// src/services/api/appApi.js
import { rootApi } from './rootApi';

export const appApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getInSeasonSports: build.query({
      query: () => '/sports/in-season',
      keepUnusedDataFor: 300, // 5 minutes cache
      providesTags: () => [{ type: 'Season', id: 'IN_SEASON_SPORTS' }],
    }),
    createCheckoutSession: build.mutation({
      query: (body) => ({
        url: 'payments/checkout-session',
        method: 'POST',
        body: body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { 
  useGetInSeasonSportsQuery,
  useCreateCheckoutSessionMutation
} = appApi;